import { render, staticRenderFns } from "./game.vue?vue&type=template&id=68c94b02&scoped=true"
import script from "./game.vue?vue&type=script&lang=js"
export * from "./game.vue?vue&type=script&lang=js"
import style0 from "./game.vue?vue&type=style&index=0&id=68c94b02&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c94b02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68c94b02')) {
      api.createRecord('68c94b02', component.options)
    } else {
      api.reload('68c94b02', component.options)
    }
    module.hot.accept("./game.vue?vue&type=template&id=68c94b02&scoped=true", function () {
      api.rerender('68c94b02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/game.vue"
export default component.exports